import { ChildProps } from '@/common/util/props'

const BadgeList = ({ children }: ChildProps) => {
  return <div className='flex items-center gap-2'>{children}</div>
}

export default BadgeList
